module.exports = __webpack_public_path__ + "app-static/img/empty_2.40f0910d.png";